import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  showSignInCta: true,
  guards: {
    registered: { action: 'block' }
  },
  redirectMap: {
    'order-confirmation': 'account-order-history'
  }
} satisfies RecursivePartial<DialogConfig['signUp']>
